<template>
  <div> <!-- keep global div to avoid vue template generation issue -->
      <div
          :class="size"
          class="spinners">
        <svg
            width="1em"
            height="1em">
          <circle
              cx="0.5em"
              cy="0.5em"
              r="0.45em"/>
        </svg>
      </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { Component, Emit, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class CircleLoader extends Vue {
  @Prop({default: 'default'})
  private size!: 'default" | "small" | "micro';

}
</script>

<style lang="scss" scoped>

.spinners circle {
  fill: transparent;
  stroke: var(--primary);
  stroke-width: 0.04em;
  stroke-linecap: round;
  stroke-dasharray: 2.3525em 0.4705em;
  animation: 1.5s strokeDashArray infinite linear;
}

.spinners circle {
  fill: transparent;
  stroke-linecap: round;
  stroke-dasharray: 2.3525em 0.4705em;
  animation: 1.5s strokeDashArray infinite linear;
}

.default{
  font-size: 4rem; /* Change this to resize the loader */
  circle{
    stroke-width: 0.04em;
  }
}
.small{
  font-size: 20px;
  circle{
    stroke-width: 0.1em;
  }
}

.micro{
  font-size: 8px;
  circle{
    stroke-width: 0.06em;
  }
}


@keyframes strokeDashArray {
  from {
    stroke-dasharray: 2.3525em 0.4705em;
    stroke-dashoffset: 0;
  }

  10% {
    stroke-dasharray: 2.3525em 0.4705em;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 0.001em 2.825em;
    stroke-dashoffset: -2.826em;
  }

  60% {
    stroke-dasharray: 0.001em 2.825em;
  }

  to {
    stroke-dasharray: 2.3525em 0.4705em;
    stroke-dashoffset: -2.826em;
  }
}
</style>
